import { SITE } from "../lib/site";
import { ArrowUpRight } from "lucide-react";

export const Gallery = () => {
  const [a, b, c] = SITE.gallery;

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-[#050505] py-24 md:py-32 border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12 md:mb-16">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-12 bg-[#FF2222]" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-white/60">The Drops</span>
            </div>
            <h2 className="font-display uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
              Gallery of Custom<br />
              Shirts & <span className="text-[#FF2222]">Spirit Wear</span>
            </h2>
          </div>
          <p className="max-w-md text-white/60 text-sm md:text-base leading-relaxed">
            A glimpse at what we press. Every design is custom — send us yours, or commission a one-of-one.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
          <GalleryCard item={a} className="md:col-span-7 md:row-span-2 aspect-[4/5] md:aspect-auto md:h-[660px]" testid="gallery-card-1" big />
          <GalleryCard item={b} className="md:col-span-5 aspect-[4/5] md:h-[322px]" testid="gallery-card-2" />
          <GalleryCard item={c} className="md:col-span-5 aspect-[4/5] md:h-[322px]" testid="gallery-card-3" />
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p className="text-white/50 text-sm uppercase tracking-[0.2em]">More on our Etsy & socials</p>
          <a
            data-testid="gallery-shop-link"
            href={SITE.social.etsy}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-white hover:text-[#FF2222] uppercase tracking-[0.2em] text-xs font-bold"
          >
            See full collection <ArrowUpRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

const GalleryCard = ({ item, className = "", testid, big = false }) => (
  <div
    data-testid={testid}
    className={`tilt-card group relative overflow-hidden border border-white/10 hover:border-[#FF2222] bg-[#0a0a0a] ${className}`}
  >
    <img
      src={item.url}
      alt={`${item.title} — custom DTF printed tee by iza3nee Creations`}
      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
      loading="lazy"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent opacity-90 group-hover:opacity-95 transition-opacity" />
    <div className="absolute inset-0 p-5 md:p-7 flex flex-col justify-end">
      <span className="text-[10px] uppercase tracking-[0.25em] text-[#FF2222] mb-2">{item.tag}</span>
      <h3 className={`font-display uppercase text-white tracking-tight leading-none ${big ? "text-3xl md:text-5xl" : "text-2xl md:text-3xl"}`}>
        {item.title}
      </h3>
    </div>
    <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
      <div className="bg-[#FF2222] text-white p-2"><ArrowUpRight size={16} /></div>
    </div>
  </div>
);
